<script setup>
import { ref, computed, onMounted } from 'vue';
import { get } from 'lodash';
import { useRoute, useRouter } from 'vue-router';

import CoverView from '@/views/shared/CoverView.vue';
import DescriptionBlock from '@/components/shared/blocks/DescriptionBlock.vue';
import ProfilesSelectList from '@/components/shared/ProfilesSelectList.vue';
import { useInstitutionStore } from '@/stores/institution';
import { useDepartmentStore } from '@/stores/department';
import { useGeneralStore } from '@/stores/general';
import { useProfilesStore } from '@/stores/profiles';
import constants from '@/utils/constants';
import MediaBlock from '@/components/shared/blocks/MediaBlock.vue';
import TitleBlock from '@/components/shared/blocks/TitleBlock.vue';
import BlocksWrapper from '@/components/shared/blocks/BlocksWrapper.vue';

const institutionStore = useInstitutionStore();
const departmentStore = useDepartmentStore();
const generalStore = useGeneralStore();
const profilesStore = useProfilesStore();
const route = useRoute();
const router = useRouter();

const showSelectDepartment = ref(false);
const isLoading = ref(true);
const selectedDepartmentId = ref(-1);
const selectedDepartment = ref();

const myArchive = computed(() => profilesStore.myArchive);

const moduleColor = computed(() => {
  return route?.meta?.color;
});

const coverImage = computed(() => {
  return get(
    selectedDepartment.value,
    'presentation.image',
    constants.placeholderImage
  );
});

const description = computed(() => {
  return get(selectedDepartment.value, 'presentation.description', '');
});

const documents = computed(() => {
  return myArchive?.value?.documents || [];
});

onMounted(async () => {
  await generalStore.setActiveContentView({});

  switchDepartment({
    id: departmentStore.id,
    type: 'DEPARTMENT',
  });

  isLoading.value = false;
});

async function switchDepartment(department) {
  const departmentId = parseInt(department.id);

  selectedDepartment.value = institutionStore.departments.find(
    (department) => parseInt(department.id) === parseInt(departmentId)
  );

  selectedDepartmentId.value = departmentId;

  await profilesStore.getMyArchive({
    id: departmentId,
    type: 'DEPARTMENT',
  });

  showSelectDepartment.value = false;
}

async function showSingleProfile(profile) {
  router.push(`/ourHome/${profile.id}`);
}
</script>

<template>
  <CoverView
    v-if="!isLoading"
    :image-url="coverImage"
    :module-color="moduleColor"
  >
    <div class="flex flex-col mb-12 relative">
      <TitleBlock :text="selectedDepartment.name" />
      <MediaBlock :documents="documents" :color="moduleColor" />

      <BlocksWrapper>
        <DescriptionBlock :description="description" :borderBottom="false" />
      </BlocksWrapper>

      <ProfilesSelectList
        class="mb-12"
        :shared-departments="institutionStore.departments"
        :selected-department="selectedDepartment"
        @department-selected="selectedDepartment = $event"
        @profile-selected="showSingleProfile($event)"
      />
    </div>
  </CoverView>
</template>

<style lang="scss">
.profile {
  .profileImage {
    &.small {
      width: 96px;
      height: 96px;
    }

    &.large {
      width: 180px;
      height: 180px;
    }
  }
}
</style>
